(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('ShowcasesLayoutTemplatesController', ShowcasesLayoutTemplatesController);

    ShowcasesLayoutTemplatesController.$inject = [
        '$state',
        '$stateParams',
        '$translate',
        'ShowcaseLayoutTemplateService',
        'ShowcasesService',
        'paginationConstants',
        'toastr',
        '$window',
        'systemConstants'
    ];

    function ShowcasesLayoutTemplatesController(
        $state,
        $stateParams,
        $translate,
        ShowcaseLayoutTemplateService,
        ShowcasesService,
        paginationConstants,
        toastr,
        $window,
        systemConstants
    ) {
        var vm = this;

        vm.isInitialLoading = true;
        vm.busy = false;
        vm.isSaving = false;
        vm.isMobile = $window.innerWidth <= systemConstants.BOOTSTRAP_RESOLUTIONS.MAX_XS;
        vm.templates = [];
        vm.showcase = null;
        vm.search = '';
        vm.selectedTemplateId = null;
        vm.page = 0;
        vm.numPerPage = paginationConstants.itemsPerPage;
        vm.itemsPerPageOptions = paginationConstants.itemsPerPageOptions;
        vm.currentPage = 1;
        vm.totalItems = 0;
        vm.startRegistry = 1;
        vm.endRegistry = vm.numPerPage;
        vm.sortDirection = 'asc';

        vm.selectedSortByOption = 'name';
        vm.sortOptions = paginationConstants.sortOptions[$translate.use().toLowerCase()].filter(function (type) {
            return type.value === 'name' || type.value === 'lastModifiedDate';
        });

        vm.$onInit = init;
        vm.loadTemplates = loadTemplates;
        vm.resetPage = resetPage;
        vm.changePage = changePage;
        vm.onChangeItemsPerPage = onChangeItemsPerPage;
        vm.onSelectedSortOption = onSelectedSortOption;
        vm.selectTemplate = selectTemplate;
        vm.isTemplateSelected = isTemplateSelected;
        vm.getStatusLabel = getStatusLabel;
        vm.finishAssociation = finishAssociation;
        vm.goBack = goBack;

        function init() {
            ShowcasesService.getShowcase($stateParams.showcaseId, $stateParams.ownerId, false).then(function (data) {
                vm.showcase = data;
                if (data.layoutTemplate && data.layoutTemplate.id) {
                    vm.selectedTemplateId = data.layoutTemplate.id;
                }
                loadTemplates();
            }, function () {
                vm.isInitialLoading = false;
                toastr.error($translate.instant('showcases.layout-templates-list.messages.load.error'));
                $state.go('showcases');
            });
        }

        function loadTemplates() {
            if (vm.busy) {
                return;
            }

            vm.busy = true;

            ShowcaseLayoutTemplateService.list({
                page: vm.page,
                size: vm.numPerPage,
                sort: buildSortParam()
            }, vm.search).then(function (response) {
                var headers = response.headers;
                vm.templates = response.data || [];
                vm.totalItems = parseInt(headers('X-Total-Count'), 10) || vm.templates.length;
                vm.startRegistry = vm.totalItems === 0 ? 0 : (vm.page * vm.numPerPage) + 1;
                vm.endRegistry = Math.min((vm.page + 1) * vm.numPerPage, vm.totalItems);
                vm.isInitialLoading = false;
                vm.busy = false;
            }, function () {
                vm.isInitialLoading = false;
                vm.busy = false;
                toastr.error($translate.instant('showcase-layout-template.messages.load.error'));
            });
        }

        function buildSortParam() {
            var sortValue = angular.isObject(vm.selectedSortByOption)
                ? vm.selectedSortByOption.value
                : vm.selectedSortByOption;
            var direction = angular.isObject(vm.selectedSortByOption)
                ? vm.selectedSortByOption.direction
                : vm.sortDirection;
            return sortValue + ',' + (direction || 'asc');
        }

        function resetPage() {
            vm.page = 0;
            vm.currentPage = 1;
            loadTemplates();
        }

        function changePage() {
            vm.page = vm.currentPage - 1;
            loadTemplates();
        }

        function onChangeItemsPerPage(newValue) {
            if (newValue === vm.numPerPage) {
                return;
            }
            vm.numPerPage = newValue;
            resetPage();
        }

        function onSelectedSortOption(newValue) {
            vm.selectedSortByOption = newValue;
            resetPage();
        }

        function selectTemplate(templateId) {
            vm.selectedTemplateId = (vm.selectedTemplateId === templateId) ? null : templateId;
        }

        function isTemplateSelected(templateId) {
            return vm.selectedTemplateId === templateId;
        }

        function finishAssociation() {
            if (!vm.showcase || !vm.showcase.id) {
                return;
            }

            var showcaseId = vm.showcase.id;
            var isAssociating = !!vm.selectedTemplateId;

            vm.isSaving = true;
            var request = isAssociating
                ? ShowcasesService.associateLayoutTemplate(showcaseId, vm.selectedTemplateId)
                : ShowcasesService.disassociateLayoutTemplate(showcaseId);

            request.then(function () {
                vm.isSaving = false;
                toastr.success($translate.instant(isAssociating
                    ? 'showcases.layout-templates-list.messages.associate.success'
                    : 'showcases.layout-templates-list.messages.disassociate.success'));
                $state.go('showcases.edit', {
                    showcaseId: showcaseId
                }, {
                    reload: true
                });
            }, function () {
                vm.isSaving = false;
                toastr.error($translate.instant(isAssociating
                    ? 'showcases.layout-templates-list.messages.associate.error'
                    : 'showcases.layout-templates-list.messages.disassociate.error'));
            });
        }

        function getStatusLabel(status) {
            return 'showcase-layout-template.status.' + (status || 'DRAFT');
        }

        function goBack() {
            $state.go('showcases.edit', {showcaseId: vm.showcase.id});
        }
    }

})();
